import * as XLSX from "xlsx";
import type { Sprint } from "@/services/sprint.service";
import type { UserGroup } from "./groupProdTasks";

export function exportProdReportXls(
	groups: UserGroup[],
	sprint: Sprint | null,
): void {
	const heading = sprint
		? `${sprint.name} (${sprint.start_date} to ${sprint.end_date})`
		: "All sprints";

	const aoa: (string | number)[][] = [];
	aoa.push([`Prod Reports - ${heading}`]);
	aoa.push([]);
	aoa.push(["User", "Project", "Task", "Status"]);

	for (const u of groups) {
		const userCell = u.email ? `${u.name} (${u.email})` : u.name;
		if (u.tasks.length === 0) {
			aoa.push([userCell, "", "", ""]);
			continue;
		}
		u.tasks.forEach((t, i) => {
			aoa.push([i === 0 ? userCell : "", t.projectName, t.title, t.statusLabel]);
		});
	}

	const ws = XLSX.utils.aoa_to_sheet(aoa);
	ws["!cols"] = [{ wch: 32 }, { wch: 28 }, { wch: 48 }, { wch: 14 }];

	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, "Prod Reports");

	const name = sprint
		? `prod-reports-${sprint.name.replace(/\s+/g, "-").toLowerCase()}`
		: "prod-reports";
	XLSX.writeFile(wb, `${name}.xlsx`);
}
